import { cn } from "../../lib/cn";
import emptyStateSrc from "../../assets/empty-state.svg";

export interface EmptyStateIllustrationProps {
  readonly className?: string;
}

/** The shared "no data" illustration -- shown above the empty-state caption
 * in DataTable and any hand-rolled table that mirrors its empty state. */
export function EmptyStateIllustration({ className }: EmptyStateIllustrationProps) {
  return (
    <img
      src={emptyStateSrc}
      alt=""
      aria-hidden="true"
      className={cn("mx-auto h-auto w-40", className)}
    />
  );
}
